import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";

export class CampaignActiveAPI extends BaseAPI<{}, {}> {
  protected route = ApiRoutes.campaign.active;
  protected method = RequestMethod.GET;
}
